import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class yAxisSide extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(side) {
    let _this = this;
    return function (event) {
      _this.props.onLegendChange("yAxisSide", side);
    };
  }

  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>Y-axis Side</div>
          <div className={styles.configRadioGroup}>
            <input type="radio" className="with-gap"
                   checked={this.props.side == "left"} onChange={() => {}}/>
            <label onClick={this.handleChange("left")}>Left</label>
            <input type="radio" className="with-gap"
                   checked={this.props.side == "right"}/>
            <label onClick={this.handleChange("right")} onChange={() => {}}>Right</label>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/yAxisSide.jsx